<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a href="#" @click.prevent="back">Шаблоны</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-if="type == 'create'">Создать новый шаблон</li>
            <li class="breadcrumb-item active" aria-current="page" v-else>Редактировать шаблон</li>
        </ol>
    </nav>

    <div class="form-narrow">
        <div class="row mb-4">
            <div class="col-12">
                <div class="form-label">Название шаблона <span class="color-red">*</span></div>
                <input type="text" class="form-control" id="nameInput" placeholder="Введите название" v-model="name">
            </div>
        </div>

        <div class="mb-4">
            <div class="form-label">Хедер открытки</div>
            <div class="file-input-group">
                <input readonly type="text" name="" id="" class="form-control file-input-group__input" v-model="headerName"
                       placeholder="Выбранный файл">
                <button class=" reset-btn file-input-group__reset" @click.prevent="clearHeaderInput">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                              fill="currentColor" />
                    </svg>
                </button>
                <button class="reset-btn file-input-group__open" @click.prevent="toggleHeaderBox"
                        :class="{ 'is-selected': boxHeaderVisible }">
                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.4 2.26707H7.66875L5.46938 0.0435975C5.44139 0.0159086 5.40458 0.000347387 5.36625 0H0.6C0.268125 0 0 0.283384 0 0.634146V12.3659C0 12.7166 0.268125 13 0.6 13H14.4C14.7319 13 15 12.7166 15 12.3659V2.90122C15 2.55046 14.7319 2.26707 14.4 2.26707Z"
                            fill="currentColor" />
                    </svg>
                </button>
            </div>

            <div class="file-upload box mt-1" v-show="boxHeaderVisible">
                <button class="reset-btn box__close" @click.prevent="toggleHeaderBox">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                              fill="currentColor" />
                    </svg>
                </button>
                <div class="file-upload__ctrls">
                    <button class="reset-btn file-upload__ctrl local">
                        Загрузить
                    </button>
                </div>
                <div class="file-upload__local-title">Загрузите файл с устройства</div>
                <div class="file-upload__dropzone" @dragenter.stop.prevent @dragover.stop.prevent
                     @drop.stop.prevent="uploadHeaderFromDropzone">
                    <div class="file-upload__dropzone-text">
                        <div class="drop-files">Перетащите файлы</div>
                        <div class="or">Или</div>
                        <button class="choose reset-btn" v-on:click.stop.prevent="uploadFileFromInputLocal">Выберите
                            файлы</button>
                    </div>
                    <input class="file-upload__local-input" type="file" name="header" id="" v-on:change="uploaded">
                </div>
            </div>
        </div>

        <div class="mb-4">
            <div class="form-label">Футер открытки</div>
            <div class="file-input-group">
                <input readonly type="text" name="" id="" class="form-control file-input-group__input" v-model="footerName" placeholder="Выбранный файл">
                <button class=" reset-btn file-input-group__reset" @click.prevent="clearFooterInput">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                              fill="currentColor" />
                    </svg>
                </button>
                <button class="reset-btn file-input-group__open" @click.prevent="toggleFooterBox"
                        :class="{ 'is-selected': boxFooterVisible }">
                    <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.4 2.26707H7.66875L5.46938 0.0435975C5.44139 0.0159086 5.40458 0.000347387 5.36625 0H0.6C0.268125 0 0 0.283384 0 0.634146V12.3659C0 12.7166 0.268125 13 0.6 13H14.4C14.7319 13 15 12.7166 15 12.3659V2.90122C15 2.55046 14.7319 2.26707 14.4 2.26707Z"
                            fill="currentColor" />
                    </svg>
                </button>
            </div>

            <div class="file-upload box mt-1" v-show="boxFooterVisible">
                <button class="reset-btn box__close" @click.prevent="toggleFooterBox">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.9992 7.94095L12.8616 13.5013L14 12.4234L8.13598 6.86304L14 1.30423L12.8632 0.224792L6.9992 5.78512L1.13679 0.224792L0 1.30423L5.86241 6.86304L0 12.4218L1.13679 13.5013L6.9992 7.94095Z"
                              fill="currentColor" />
                    </svg>
                </button>
                <div class="file-upload__ctrls">
                    <button class="reset-btn file-upload__ctrl local">
                        Загрузить
                    </button>
                </div>
                <div class="file-upload__local-title">Загрузите файл с устройства</div>
                <div class="file-upload__dropzone" @dragenter.stop.prevent @dragover.stop.prevent @drop.stop.prevent="uploadFooterFromDropzone">
                    <div class="file-upload__dropzone-text">
                        <div class="drop-files">Перетащите файлы</div>
                        <div class="or">Или</div>
                        <button class="choose reset-btn" v-on:click.stop.prevent="uploadFileFromInputLocal">Выберите
                            файлы</button>
                    </div>
                    <input class="file-upload__local-input" type="file" name="footer" id="" v-on:change="uploaded">
                </div>
            </div>
        </div>

        <div class="d-flex w-50 align-items-center justify-content-start">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="save"/>
            <button class="btn btn-lg btn-outline-dark" @click.prevent="back">
                <span>Отменить</span>
            </button>
        </div>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: 'GrattersCreateComponent',
    components: { Alert, ConfirmBtn },
	props: [
        'type',
		'element_id',
		'route_detail',
        'route_list',
        'route_upload',
        'route_save'
    ],
	data: () => {
        return {
            name: '',
            header: '',
            headerName: '',
            footer: '',
            footerName: '',
			boxHeaderVisible: false,
			boxFooterVisible: false,
        };
    },
	methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
		save: function () {
            const data = {
                name: this.name,
                header: this.header,
                headerName: this.headerName,
                footer: this.footer,
                footerName: this.footerName,
            }
            if(this.type == 'edit') {
				data.id = this.element_id;
			}
			axios.post(this.route_save, data)
				.then(res => {
					if(res.data.status == 'error') {
                        this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
                        this.toggleLoading();
					} else if(res.data.status == 'ok') {
						document.location = this.route_list;
					}
				});
		},
		back: function () {
			document.location = this.route_list;
		},
		toggleHeaderBox() {
            this.boxHeaderVisible = !this.boxHeaderVisible
        },
		toggleFooterBox() {
            this.boxFooterVisible = !this.boxFooterVisible
        },
		uploadFileFromInputLocal(e) {
            let fileInput = e.currentTarget.closest('.file-upload__dropzone').querySelector('.file-upload__local-input') || false
            fileInput.click()
        },
		clearHeaderInput() {
			this.header = '';
			this.headerName = '';
		},
		clearFooterInput() {
			this.footer = '';
			this.footerName = '';
		},
        uploadHeaderFromDropzone(e) {
            let dt = e.dataTransfer
            let files = dt.files
			if(files.length > 0) {
				const formData = new FormData();
				formData.append("image", files[0]);
				formData.append("resize", 600);
				axios.post(this.route_upload, formData)
					.then(res => {
						if(res.data.status == 'ok') {
							this.header = res.data.url;
							this.headerName = res.data.name;
							this.boxHeaderVisible = false;
						} else {
                            this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
						}
					})
            }
        },
		uploadFooterFromDropzone(e) {
            let dt = e.dataTransfer
            let files = dt.files
			if(files.length > 0) {
				const formData = new FormData();
				formData.append("image", files[0]);
				formData.append("resize", 600);
				axios.post(this.route_upload, formData)
					.then(res => {
						if(res.data.status == 'ok') {
							this.footer = res.data.url;
							this.footerName = res.data.name;
							this.boxFooterVisible = false;
						} else {
                            this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
						}
					})
            }
        },
		uploaded: function (e) {
			if(e.target.files.length > 0) {
				const formData = new FormData();
				formData.append("image", e.target.files[0]);
				formData.append("resize", 600);
				axios.post(this.route_upload, formData)
					.then(res => {
						if(res.data.status == 'ok') {
							if(e.target.name == 'header') {
								this.header = res.data.url;
								this.headerName = res.data.name;
								this.boxHeaderVisible = false;
							} else if(e.target.name == 'footer') {
								this.footer = res.data.url;
								this.footerName = res.data.name;
								this.boxFooterVisible = false;
							}
						} else {
                            this.addAlert({ type: 'error', title: 'Ошибка', text: res.data.message });
						}
					})
            }
        },
	},
	mounted() {
		if(this.type == 'edit') {
			axios.post(this.route_detail, {id: this.element_id})
				.then(res => {
					this.name = res.data.data.name;
					this.header = res.data.data.header ? res.data.data.header : '';
					this.headerName = res.data.data.header_name ? res.data.data.header_name : '';
					this.footer = res.data.data.footer ? res.data.data.footer : '';
					this.footerName = res.data.data.footer_name ? res.data.data.footer_name : '';
				});
		}
    },
}
</script>

<style scoped lang="scss">
.file-input-group {
    display: flex;
    align-items: stretch;
    max-width: 526px;

    @media screen and (max-width: 767px) {
        max-width: unset;
    }

    &__input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    &__reset,
    &__open {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        color: #A8A8A8;
        border: 1px solid #D1D1D1;
        border-left: none;
        transition: 50ms ease-in-out color;

        &:hover,
        &:focus-visible {
            outline: none;
            color: #0095D6;;
        }

        &:active {
            color: #45C7FF;
        }
    }

    &__open.is-selected {
        color: #0095D6;
    }

    &__reset {
        width: 35px;
    }

    &__open {
        width: 39px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}

.file-upload {
    display: grid;
    grid-template-columns: 188px auto;
    grid-template-rows: max-content max-content max-content;
    gap: 20px;
    padding-left: 8px !important;
    max-width: 623px;

    @media screen and (max-width: 767px) {
        max-width: unset;
    }

    @media screen and (max-width: 575px) {
        grid-template-columns: 95px auto;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    &__ctrls {
        grid-column: 1;
        grid-row: 1/3;

        @media screen and (max-width: 575px) {
            grid-row: 1;
        }
    }

    &__ya-title,
    &__local-title {
        font-weight: 600;
        font-size: 16px;
        text-align: center;

        @media screen and (max-width: 767px) {
            font-size: 12px;
        }
    }

    &__ya-title {
        grid-column: 2;
        grid-row: 1;
    }

    &__local-title {
        display: none;

        @media screen and (max-width: 575px) {
            display: block;
            text-align: left;
        }
    }

    &__dropzone {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        grid-column: 2;
        grid-row: 1/4;
        padding: 10px;
        border: 1px dashed #A8A8A8;
        border-radius: 5px;
        min-height: 196px;
        cursor: auto;

        @media screen and (max-width: 575px) {
            grid-row: 2;
            grid-column: 1/3;
            padding: 0;
            min-height: unset;
            border: none;
        }
    }

    &__ya-link {
        grid-column: 2;
        grid-row: 2;

        @media screen and (max-width: 575px) {
            grid-column: 1/3;
        }
    }

    &__ya-up-btn-wrap {
        grid-column: 2;
        grid-row: 3;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__ctrl {
        display: flex;
        align-items: center;
        width: 100%;
        min-height: 46px;
        padding: 10px;
        cursor: pointer;
        border-radius: 3px;
        background-color: #FBFBFB;
        color: #333333;
        font-size: 16px;
        letter-spacing: 0.01em;
        line-height: 1.5;
        transition: 50ms ease-in-out background-color;

        @media screen and (max-width: 767px) {
            padding: 7px 10px;
            font-size: 12px;
            min-height: 33px;
        }

        &:hover {
            background-color: #ECECEC;
        }

        &.is-selected {
            background-color: #ECECEC;
        }

        &:not(:last-child) {
            margin-bottom: 1px;
        }
    }

    &__ya-link-label {
        margin-bottom: 10px;
        font-size: 16px;

        @media screen and (max-width: 767px) {
            margin-bottom: 7px;
            font-size: 12px;
        }
    }

    &__local-btn-wrap {
        display: flex;
        align-items: flex-end;
        grid-column: 1;
        grid-row: 3;

        @media screen and (max-width: 575px) {
            display: flex;
            justify-content: center;
            grid-column: 1/3;
        }
    }

    &__dropzone-text {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        line-height: 1.5;
        letter-spacing: 0.01em;
        color: #333333;

        .drop-files {
            margin-bottom: 14px;
            font-size: 18px;
            font-weight: 600;
            text-transform: uppercase;
        }

        .or {
            margin-bottom: 14px;
            font-size: 16px;
            text-transform: uppercase;
        }

        .choose {
            padding: 9px 28px;
            font-size: 16px;
            color: #A8A8A8;
            border-radius: 5px;
            border: 1px solid #00D515;
            text-transform: uppercase;
            cursor: pointer;
            transition: 50ms ease-in-out color;

            &:hover {
                color: #333333;
            }
        }

        @media screen and (max-width: 575px) {
            width: 100%;

            .drop-files,
            .or {
                display: none;
            }

            .choose {
                padding: 12px;
                width: 100%;
                font-size: 14px;
                text-transform: none;
            }
        }
    }

    &__local-input {
        position: absolute;
        margin-left: -1px;
        width: 1px;
        height: 1px;
        clip-path: inset(2px);
    }
}

.file-upload-btn {
    font-size: 14px;
    color: #00D515;
    text-align: left;
}
</style>